export enum wareHouseReceiptsTypes {
  GET_WAREHOUSERECEIPTS = '@@wareHouseReceipts/GET_WAREHOUSERECEIPTS',
  GET_WAREHOUSERECEIPTS_SUCCESS = '@@wareHouseReceipts/GET_WAREHOUSERECEIPTS_SUCCESS',
  GET_WAREHOUSERECEIPTS_FAIL = '@@wareHouseReceipts/GET_WAREHOUSERECEIPTS_FAIL',

  GET_MILESTONESCONFIG_WR = "@WR/GET_MILESTONECONFIG",
  GET_MILESTONESCONFIG_WR_SUCCESSS = "@WR/GET_MILESTONECONFIG_SUCCESS",
  GET_MILESTONESCONFIG_WR_FAIL = "@WR/GET_MILESTONECONFIG_FAIL"
}
